import { AB_TESTS } from '../services/abTesting/abTests';
import { getABTestValue, useGetABTestValue } from '../services/abTesting/useGetABTest';

export const useCheapOfferingPaywall = () => {
  const cheapOffering: number | null = useGetABTestValue(AB_TESTS.CHEAP_OFFERING);

  return {
    isCheapOffering: !!cheapOffering,
  };
};

export const getCheapOfferingPaywall = async () => {
  const cheapOffering: number | null = await getABTestValue(AB_TESTS.CHEAP_OFFERING);

  return {
    isCheapOffering: !!cheapOffering,
  };
};
